import Vue from "vue";
import VueRouter from "vue-router";
import Layout from '../views/layout/index.vue'
Vue.use(VueRouter);

const routes = [
  {
    path: "main",
    name: "main",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/main/index.vue")
  },
  {
    path: "knowledge",
    name: "knowledge",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/knowledge/index.vue")
  },
  {
    path: "variable",
    name: "variable",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/variable/index.vue")
  },
  {
    path: "rules",
    name: "rules",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/rules/index.vue")
  },
  {
    path: "eventRules",
    name: "eventRules",
    component: () =>
      import(/* webpackChunkName: "eventRules" */ "../views/eventRules/index.vue")
  },
  {
    path: "intent",
    name: "intent",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/intent/index.vue")
  },
  {
    path: "texteditor",
    name: "texteditor",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/texteditor/index.vue")
  },
  {
    path: "aiDetection",
    name: "aiDetection",
    component: () =>
      import(/* webpackChunkName: "aiDetection" */ "../views/aiDetection/index.vue")
  },
  {
    path: 'llm',
    name: "llm",
    component: () =>
      import(/* webpackChunkName: "llm" */ "../views/llm/index.vue")
  },
  {
    path: "debugger",
    name: "debugger",
    component: () =>
      import(/* webpackChunkName: "debugger" */ "../views/debugger/index.vue")
  },
  {
    path: 'nodeHitRate',
    name: "nodeHitRate",
    component: () =>
      import(/* webpackChunkName: "nodeHitRate" */ "../views/nodeHitRate/index.vue")
  }
];

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/:id',
      redirect: 'main',
      component: Layout,
      children: routes,
    },
  ],
});

export default router;
